__turbopack_context__.v({
  "bg": "landing-footer-module-scss-module__o6Ouda__bg",
  "col": "landing-footer-module-scss-module__o6Ouda__col",
  "contacts": "landing-footer-module-scss-module__o6Ouda__contacts",
  "content": "landing-footer-module-scss-module__o6Ouda__content",
  "copyright": "landing-footer-module-scss-module__o6Ouda__copyright",
  "description": "landing-footer-module-scss-module__o6Ouda__description",
  "icon": "landing-footer-module-scss-module__o6Ouda__icon",
  "links": "landing-footer-module-scss-module__o6Ouda__links",
  "links_info": "landing-footer-module-scss-module__o6Ouda__links_info",
  "links_social": "landing-footer-module-scss-module__o6Ouda__links_social",
  "navigation": "landing-footer-module-scss-module__o6Ouda__navigation",
  "navigation_col": "landing-footer-module-scss-module__o6Ouda__navigation_col",
  "reg_info": "landing-footer-module-scss-module__o6Ouda__reg_info",
  "root": "landing-footer-module-scss-module__o6Ouda__root",
  "social_icons": "landing-footer-module-scss-module__o6Ouda__social_icons",
  "text": "landing-footer-module-scss-module__o6Ouda__text",
});
